export class MaintenanceLog {
    logUID?: string;
    maintenanceUID!: string;
    date: Date = new Date();
    action!: string;
    notes?: string;
    userUID?: string;
    userName?: string;
    documentUIDs?: string[]; // Associated document IDs

    constructor(maintenanceUID: string, action: string, notes?: string) {
        this.maintenanceUID = maintenanceUID;
        this.action = action;
        this.notes = notes;
    }
} 